'use client'

import { useState } from 'react'

import { useCartStore } from 'modules/cart'
import Button from 'shared/ui/Button'
import { Modal, ModalDescription, ModalTitle } from 'shared/ui/Modal'

import { useEditSaleOrderActions } from '../hooks/useEditSaleOrderActions'

import styles from './CancelEditSaleOrderModal.module.scss'

const CancelEditSaleOrderModal = ({
  onClose,
  open
}: {
  onClose: () => void
  open: boolean
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { cart } = useCartStore()
  const { cancelEditSaleOrder } = useEditSaleOrderActions()

  const handleCancelOrder = async () => {
    if (cart?.saleOrderId) {
      setIsLoading(true)
      try {
        await cancelEditSaleOrder(cart.saleOrderId)
        onClose()
      } catch (error) {
        console.error(error)
        setIsLoading(false)
      }
    }
  }

  return (
    <Modal
      id='cancel-edit-order-modal'
      open={open}
      onClose={onClose}
      size='small'
    >
      <ModalTitle>Anuluj edycję</ModalTitle>
      <ModalDescription>
        Czy na pewno chcesz wyjść z edycji zamówienia bez zapisywania zmian?
      </ModalDescription>
      <div className={styles.buttonContainer}>
        <Button
          variant='primary'
          fullWidth
          disabled={isLoading}
          loading={isLoading}
          onClick={handleCancelOrder}
        >
          Wyjdź
        </Button>
        <Button variant='neutral' fullWidth onClick={onClose}>
          Anuluj
        </Button>
      </div>
    </Modal>
  )
}

export default CancelEditSaleOrderModal
